import { BillingChangeRequestType as BillingChangeRequestTypeEnum } from "~/graphql/supergraphEnums";
import type { BillingChangeRequestType } from "~/graphql/supergraphTypes";

export const isGpEumRequestType = (
  requestType: BillingChangeRequestType | null | undefined,
): boolean =>
  requestType === BillingChangeRequestTypeEnum.EumValueOverride ||
  requestType === BillingChangeRequestTypeEnum.EumCalcEdit;
